module.exports = __webpack_public_path__ + "images/mobile_app_preview.webp";